// extracted by mini-css-extract-plugin
export default {"iframe":"Iframe_iframe__EfVbf"};